import { h } from 'preact';
import DriverMarkerSVG from '../../components/svg-components/driver-marker-svg';
import TaskMarkerSVG from '../../assets/task-marker.svg';
import { isEmpty as _isEmpty } from 'lodash';
import AddressIcon from '../../components/select-pickup-location/select-pickup/address-icon/address-icon';
import { Team } from '@bringg/types';
import { map as _map } from 'lodash';
import { MarkerData } from '../../components/map/map-marker/map-marker';

// TODO: remove when doing new API refactor
const isDefaultDriverImage = driverImage => driverImage && driverImage.includes('/images/pin_delivery.png');
const isDefaultTaskLocationImage = taskImage => taskImage && taskImage.includes('/images/pin_destination.png');

export const getDriverMarker = (driverMarkerUrl: string, primaryColor: string) => {
	if (_isEmpty(driverMarkerUrl) || isDefaultDriverImage(driverMarkerUrl)) {
		return <DriverMarkerSVG color={primaryColor} />;
	}

	return <img src={driverMarkerUrl} alt="driver" />;
};

export const getTaskMarker = (taskMarkerUrl: string) => {
	return (
		<img
			src={_isEmpty(taskMarkerUrl) || isDefaultTaskLocationImage(taskMarkerUrl) ? TaskMarkerSVG : taskMarkerUrl}
			alt="order"
		/>
	);
};

export const getSelectPickupMarker = (position: number, isSelected: boolean) => {
	return <AddressIcon position={position} withOpacity={!isSelected} />;
};

export const getSelectPickupMarkers = (teams: Partial<Team>[], selectedIndex: number): MarkerData[] => {
	return _map(teams, (team, index) => {
		return {
			position: { lat: team.lat, lng: team.lng },
			icon: getSelectPickupMarker(index + 1, index === selectedIndex)
		};
	});
};
